import { Link } from "react-router-dom";
import { CONTACT, NAV, SERVICES } from "@/data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-primary-foreground/60 mb-4">Ready when you are</p>
          <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[0.95] max-w-3xl">
            Let's bring wellness to your door.
          </h2>
          <Link
            to="/booking"
            data-testid="footer-book-btn"
            className="inline-flex mt-8 items-center rounded-full bg-secondary text-secondary-foreground px-8 py-4 font-semibold hover:bg-secondary/90 transition-colors"
          >
            Book Your Treatment
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-primary-foreground/15 pt-12">
          <div>
            <img src="/logo.png" alt="Risi Wellness" width="64" height="64" decoding="async" className="h-16 w-16 object-contain bg-primary-foreground rounded-full p-1 mb-4" />
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Professional mobile massage & holistic therapy across Manchester & surrounding areas.
            </p>
          </div>
          <div>
            <h4 className="font-serif text-xl mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              {NAV.map((n) => (
                <li key={n.to}><Link className="hover:text-secondary transition-colors" to={n.to}>{n.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-xl mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}><Link className="hover:text-secondary transition-colors" to={`/services/${s.slug}`}>{s.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-xl mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>Tel: {CONTACT.landline}</li>
              <li>Mob: {CONTACT.mobile}</li>
              <li>{CONTACT.email}</li>
              <li>{CONTACT.address}</li>
            </ul>
            <div className="mt-5 flex flex-wrap gap-4 text-sm">
              {CONTACT.socials.instagram && <a href={CONTACT.socials.instagram} target="_blank" rel="noreferrer" className="hover:text-secondary">Instagram</a>}
              {CONTACT.socials.tiktok && <a href={CONTACT.socials.tiktok} target="_blank" rel="noreferrer" className="hover:text-secondary">TikTok</a>}
              {CONTACT.googleBusinessProfile && <a href={CONTACT.googleBusinessProfile} target="_blank" rel="noreferrer" className="hover:text-secondary">Google Business Profile</a>}
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/15 mt-12 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-primary-foreground/50">
          <p>© {new Date().getFullYear()} Risi Wellness Limited. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/legal/privacy" className="hover:text-secondary">Privacy Policy</Link>
            <Link to="/legal/cookies" className="hover:text-secondary">Cookie Policy</Link>
            <Link to="/legal/terms" className="hover:text-secondary">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
